<ngx-spinner [name]="'valores-minimos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Valores mínimos e pagamentos</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="valoresForm">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para pedidos</mat-label>
                        <input matInput formControlName="minimoPedido" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.minimoPedido.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoPedido.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para boletos</mat-label>
                        <input matInput formControlName="minimoBoleto" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.minimoBoleto.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoBoleto.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para gerar boleto de 15 dias</mat-label>
                        <input matInput formControlName="minimoBoletoQuinzeDias" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.minimoBoletoQuinzeDias.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoBoletoQuinzeDias.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para optar parcelar em dois boletos</mat-label>
                        <input matInput formControlName="minimoDivisaoPagamentoDoisBoletos" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.minimoDivisaoPagamentoDoisBoletos.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoDivisaoPagamentoDoisBoletos.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para cheque</mat-label>
                        <input matInput formControlName="minimoCheque" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-hint align="end">Somente clientes com permissão</mat-hint>
                        <mat-error *ngIf="f.minimoCheque.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoCheque.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <mat-divider></mat-divider>
            <div class="row mt-2">
                <div class="col-auto">
                    <div class="custom-checkbox custom-control ml-2">
                        <input type="checkbox" formControlName="bHabilitarPix" id="habilitar_pix"
                            class="custom-control-input" />
                        <label for="habilitar_pix" class="custom-control-label">
                            Habilitar forma de pagamento PIX
                        </label>
                    </div>
                </div>

                <div class="col-auto ml-2">

                    <!-- Checkbox -->
                    <div class="custom-checkbox custom-control ml-2">
                        <input type="checkbox" formControlName="bHabilitarDescontoDinheiro" id="desconto_pix"
                            class="custom-control-input" />
                        <label for="desconto_pix" class="custom-control-label">
                            Habilitar desconto Dinheiro
                        </label>
                    </div>

                    <!-- Input -->
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Desconto compras Dinheiro %</mat-label>
                        <input matInput currencyMask
                            [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                            formControlName="porcentagemDescontoComprasDinheiro" required>
                    </mat-form-field>
                </div>

                <div class="div-col-auto mt-4">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Mínimo para desconto dinheiro</mat-label>
                        <input matInput formControlName="minimoDescontoCompraDinheiro" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.minimoDescontoCompraDinheiro.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.minimoDescontoCompraDinheiro.errors?.min">
                            O valor mínimo é 0
                        </mat-error>
                    </mat-form-field>

                </div>
            </div>

        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <div class="row mt-4">
        <div class="col-sm text-right">
            <button mat-flat-button color="primary" (click)="salvar()">
                <mat-icon>check</mat-icon> Salvar
            </button>
        </div>
    </div>

    <!-- <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="primary" (click)="salvar()">
            <mat-icon>check</mat-icon> Salvar
        </button>
    </section> -->
</mat-card>